import { StatusBadge, type StatusBadgeConfigMap } from '@/components/ui/status-badge';
import {
  StatusActiveIcon,
  StatusCancelledIcon,
  StatusDraftIcon,
} from '@components/icons/StatusIcons';
import { cn } from '@/lib/utils';

const PUBLISHED_EVENT_STATUSES = ['confirmed', 'preparing', 'ready', 'delivered'] as const;

export type EventPublishStatus = 'draft' | 'published' | 'cancelled';

export function eventPublishStatus(eventStatus: string): EventPublishStatus {
  if (eventStatus === 'cancelled') return 'cancelled';
  if ((PUBLISHED_EVENT_STATUSES as readonly string[]).includes(eventStatus)) return 'published';
  return 'draft';
}

export const EVENT_STATUS_BADGE_CONFIG: StatusBadgeConfigMap<EventPublishStatus> = {
  published: {
    label: 'Published',
    icon: <StatusActiveIcon className="size-4 flex-shrink-0 text-confirmed-green" aria-hidden="true" />,
    bgClassName: 'bg-yield-positive-bg',
    borderClassName: 'border-yield-positive-border',
    textClassName: 'text-confirmed-green',
  },
  draft: {
    label: 'Draft',
    icon: <StatusDraftIcon className="size-4 flex-shrink-0 text-turmeric-yellow" aria-hidden="true" />,
    bgClassName: 'bg-custard-yellow',
    borderClassName: 'border-butter-yellow',
    textClassName: 'text-turmeric-yellow',
  },
  cancelled: {
    label: 'Cancelled',
    icon: <StatusCancelledIcon className="size-4 flex-shrink-0 text-chilli-red" aria-hidden="true" />,
    bgClassName: 'bg-chilli-blush',
    borderClassName: 'border-chilli-red-light',
    textClassName: 'text-chilli-red',
  },
};

export interface EventStatusBadgeProps {
  status: string;
  className?: string;
}

export function EventStatusBadge({ status, className }: EventStatusBadgeProps) {
  return (
    <StatusBadge
      value={eventPublishStatus(status)}
      config={EVENT_STATUS_BADGE_CONFIG}
      className={cn('h-[27px] w-[123px] p-0', className)}
    />
  );
}
